export const REPORT_STATE = {
  INITIALIZED: 'INITIALIZED',
  FILLING_FORM: 'FILLING_FORM',
  COMPLETED: 'COMPLETED',
};
